import { CommonModule } from '@angular/common';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MobMaskModule } from '../shared/directives/mob-mask/mob-mask.module';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { RecaptchaService } from '../shared/services/recaptcha.service';
import { AccountConfirmationInformationComponent } from './account-registration/account-confirmation-information/account-confirmation-information.component';
import { AccountHeaderComponent } from './account-registration/account-header/account-header.component';
import { AccountRegistrationComponent } from './account-registration/account-registration.component';
import { BillingInformationComponent } from './account-registration/billing-information/billing-information.component';
import { ContactsInformationComponent } from './account-registration/contacts-information/contacts-information.component';
import { MdgTextFilterDirective } from './account-registration/mdg-text-filter.directive';
import { PhoneMaskModule } from './account-registration/phone-mask.module';
import { ShippingInformationComponent } from './account-registration/shipping-information/shipping-information.component';
import { GoogleAddressDirective } from './google-address.directive';
import { AccountInformationComponent } from './user-registration/account-information/account-information.component';
import { UserConfirmationComponent } from './user-registration/user-confirmation/user-confirmation.component';
import { UserHeaderComponent } from './user-registration/user-header/user-header.component';
import { UserInformationComponent } from './user-registration/user-information/user-information.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { ZipMaskDirective } from './zip-mask.directive';


function loadRecaptcha(recaptchaService: RecaptchaService) {
  return () => recaptchaService.loadRecaptchaConfig();
}

const startIndex = 6;
const totalCharsNeeded = 2;
const language = location.pathname.substr(startIndex, totalCharsNeeded);


@NgModule({
  declarations: [
    AccountRegistrationComponent,
    UserRegistrationComponent,
    BillingInformationComponent,
    ShippingInformationComponent,
    ContactsInformationComponent,
    AccountConfirmationInformationComponent,
    AccountHeaderComponent,
    AccountInformationComponent,
    UserInformationComponent,
    UserHeaderComponent,
    UserConfirmationComponent,
    ZipMaskDirective,
    MdgTextFilterDirective,
    GoogleAddressDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbPopoverModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NeedAssistanceModule,
    MobMaskModule,
    PhoneMaskModule,
    FluDashboardBannerModule,
    BsDatepickerModule.forRoot(),
    ConfigModule.withConfig({
      cmsComponents: {
        RegistrationPageComponent: {
          component: AccountRegistrationComponent,
        },
        CustomerRegistrationPageComponent: {
          component: UserRegistrationComponent,
        },
        UserRegistrationPageComponent: {
          component: UserConfirmationComponent,
        },
        AccountRegistrationPageComponent: {
          component: AccountConfirmationInformationComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (loadRecaptcha)(inject(RecaptchaService));
        return initializerFn();
      })
  ],

  exports: [PhoneMaskModule, ZipMaskDirective, MdgTextFilterDirective],
})
export class CustomUserRegistrationModule { }
